// Orchestrator lives in `owa-mail-popout-reading-pane` so it can call
// `lazyReplyToMessage` without `owa-personal-os-option` depending on
// the mail compose stack — that direct dep would close a project-ref
// cycle through Copilot Settings.

import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OpenDraftReplyFromBriefingActionMessage {
    messageId: string;
    body: string;
    mailboxInfo: MailboxInfo;
}

export const openDraftReplyFromBriefing: (
    messageId: string,
    body: string,
    mailboxInfo: MailboxInfo
) => OpenDraftReplyFromBriefingActionMessage = action(
    'OPEN_DRAFT_REPLY_FROM_BRIEFING',
    (messageId: string, body: string, mailboxInfo: MailboxInfo) => ({
        messageId,
        body,
        mailboxInfo,
    })
);
